<template>
  <div class="q-pa-xs bg-white">
    <q-page-sticky
      position="bottom"
      :offset="[20, 20]"
      v-show="this.$store.getters['TSZ/isOffline']"
    >
      <q-chip color="primary" text-color="white">
        <q-circular-progress
          indeterminate
          size="25px"
          :thickness="0.3"
          color="white"
          center-color="primary"
          track-color="transparent"
          class="q-mr-sm"
          v-show="!isLoading"
        />
        {{ contenido_mensaje }}
      </q-chip>
    </q-page-sticky>
  </div>
</template>
<script>
import { QCircularProgress, QPageSticky } from 'quasar';
export default {
  props: ['contenido_mensaje'],
  components: { QCircularProgress, QPageSticky },
  data () {
    return {
      isLoading: false
    };
  },
  methods: {},
  computed: {},
  watch: {}
};
</script>
